import { forwardRef, useState } from "react";
import {
    Box,
    Dialog,
    Divider,
    Slide
} from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as QuestionIcon } from '../assets/question.svg';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function HomeHelpClass() {
    const [open, setOpen] = useState(false);
    const openClick = () => {
        setOpen(true);
    };
    const closeClick = () => {
        setOpen(false);
    };
    return (
        <>
            <Dialog open={open} onClose={closeClick} TransitionComponent={Transition}>
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}>
                    <img src='/img/back_button_black.png' onClick={closeClick} />
                    <Box
                        sx={{
                            margin: '25px 0 0 10px',
                            fontSize: '22px'
                        }}>
                        클래스쿠폰 안내
                    </Box>
                </Box>
                <Divider />
                <Box
                    sx={{
                        // background: '#f1f2f2',
                        margin: '20px',
                        padding: '20px',
                        borderRadius: '5px'
                    }}>
                    <Box
                        sx={{
                            fontSize: '14px'
                        }}>
                        수업 예약을 하기 위해 필요한 쿠폰입니다.
                        <br></br>
                        쿠폰구매에서 구매하여 수업예약에 사용할 수 있습니다.
                        <br></br>
                        <br></br>
                        클래스 쿠폰 취소는 수업 시작 1일 전까지 가능합니다.
                        <br></br>
                    </Box>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        textAlign: 'center'
                    }}>
                    <img src='/img/use_class.jpg'
                        style={{
                            width: '100%',
                        }} />
                </Box>
                
            </Dialog>

            <QuestionIcon
                style={{
                    width: '16px',
                    height: '16px',
                    position: 'absolute',
                    top: '0',
                    right: '12px',
                }}
                onClick={openClick} />
            
        </>
    )
}

export default HomeHelpClass;